

const isTwitterUserAccount = (string) => {
    const twitterUserRe = new RegExp("^@[a-zA-Z-à-ú0-9_.]{0,100}.$");
    return twitterUserRe.test(string.trim());
}

const formatTarjaText = (text, cssSpanStyle) => {
    // retorna o texto da tarja com hashtags e @'s delimitados entre tags span para diferenciar na estilização.
    const words = text.replaceAll("\n", " ").split(" ");
    const hashtagRe = new RegExp("(?<!\\S)#\\S+|\\S+#(?!\\S)")
    const twitterUserRe = new RegExp("^@[a-zA-Z-à-ú0-9_.]{0,100}.$");
    const newWords = words.map((word) => {
        let result = word
        const wordHasHashtag = hashtagRe.test(word)
        const wordHasUser = twitterUserRe.test(word)
        if(wordHasHashtag || wordHasUser) {
            const ponctuationRe = new RegExp("\\p{P}+$", "umg")
            if(ponctuationRe.test(word)) {
                result = `<span style="${cssSpanStyle}">${word.slice(0, word.length - 1)}</span>${word.slice(-1)}`;
            } else {
                result = `<span style="${cssSpanStyle}">${word}</span>`
            }
        }
                return result;
    })
    return newWords.join(" ").trim()
}

export { isTwitterUserAccount, formatTarjaText }